import {fromJS} from 'immutable'

import {
  MESSAGE_TYPES
} from '../../config/constants'

const {ADVERTISEMENT_BOT} = MESSAGE_TYPES

import isOneHourBefore from './is_one_hour_before'

const addAdvertisementMessageAsNewBatch = (batch, message) => {
  return batch.unshift(fromJS({
    messages: [message],
    type: ADVERTISEMENT_BOT,
    from: message.get('from'),
    lastMessageTime: message.get('time')
  }))
}

const addMessageAsNewBatch = (batch, message) => {
  return batch.unshift(fromJS({
    messages: [message],
    from: message.get('from'),
    lastMessageTime: message.get('time')
  }))
}

const addMessageToBatch = (batch, message) => {
  return batch.setIn(
    [0, 'messages'],
    batch.getIn([0, 'messages']).unshift(fromJS(message))
  )
}

const reduceMessages = (batch, message) => {
  if (message.get('type') === ADVERTISEMENT_BOT) {
    return addAdvertisementMessageAsNewBatch(batch, message)
  } 

  if (batch.size === 0) return addMessageAsNewBatch(batch, message)

  const messageUser = message.get('from')
  const messageTime = message.get('time')
  const firstMessageUser = batch.getIn([0, 'messages', 0, 'from'])
  const lastMessageTime = batch.getIn([0, 'lastMessageTime'])

  if (messageUser === firstMessageUser && !isOneHourBefore(messageTime, lastMessageTime)) {
    return addMessageToBatch(batch, message)
  }
  else {
    return addMessageAsNewBatch(batch, message)
  }
}

export default (messages) => {
  return messages.reduceRight(reduceMessages, fromJS([]))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/batch_messages.js
 **/